import { useContext } from 'react';

import { useAppSelector } from '@/store';

import { OfferStepContext } from '../offer-step';
import type {
  TAlternativeBankOffer,
  TBankOffers
} from '../types/bank-offer.types';

interface IProps {
  bankOffer: TBankOffers;
}

const useSelectOffer = ({ bankOffer }: IProps) => {
  const { loan } = useAppSelector((state) => state.newOrder);
  const { onAcceptOffer, onNewAcceptModal } = useContext(OfferStepContext);

  const handleSelect = (data?: TBankOffers) => {
    // Spread двух TBankOffers даёт смешанный тип, не совпадающий ни с одной
    // ветвью union. В runtime значения корректны, поэтому используем assertion.
    onAcceptOffer({
      ...bankOffer,
      ...(data || {}),
      offerId: data?.extId || bankOffer.extId || bankOffer.offerId,
      additionalConditions:
        data && 'additionalConditions' in data
          ? data.additionalConditions
          : undefined
    } as TBankOffers);
  };

  const handleNewSelect = (offer: TBankOffers | TAlternativeBankOffer) => {
    const responseId = 'responseUuid' in offer ? offer.responseUuid : offer.id;
    const offerId = 'offerId' in offer ? offer.offerId : offer.extUuid;
    onNewAcceptModal({
      responseId,
      offerId,
      loanAmount: Number(offer.loanAmount.replace(/\D/g, '')),
      initialPayment: Number(offer.initialPayment.replace(/\D/g, '')),
      monthlyPayment: Number(offer.monthlyPayment.replace(/\D/g, '')),
      rate: Number(offer.rate),
      loanPeriod: offer.loanPeriod,
      product: loan.auto || '',
      insuranceAmount: Number(offer.insuranceAmount),
      bank: bankOffer.bank,
      additionalConditions:
        offer && 'additionalConditions' in offer
          ? offer.additionalConditions
          : undefined
    });
  };

  return { handleSelect, handleNewSelect };
};

export default useSelectOffer;
